import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const ReembolsoIntegralSection = () => {
  return (
    <section className=" py-10 md:py-24 bg-white">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <p className="text-n-text-neutral mb-2">Reembolso</p>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              Mudança de Planos? Garantimos reembolso integral
            </h2>
            <p className="md:text-lg text-n-text-neutral mb-6">
              Sabemos que imprevistos acontecem. Por isso,{" "}
              <strong>oferecemos reembolso total</strong> em casos de
              cancelamento antes do início do transporte, sem burocracia, sem
              letrinhas miúdas.Tudo está previsto na nossa política de
              reembolso, desenvolvida para garantir segurança e flexibilidade
              para você. Conheça nossa política
            </p>

            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-green-800">
                <strong>Política de Cancelamento:</strong> Cancelamentos
                realizados até 24 horas antes do horário agendado para coleta
                têm direito ao reembolso integral.
              </p>
            </div>
            <Link to="/termos">
              <Button>Ver Política Completa</Button>
            </Link>
          </div>

          <div className="flex items-center justify-center">
            <ImageSvg
              src="reembolso.svg"
              alt="Garantia de reembolso integral"
              className="md:max-w-[60%] max-w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
